import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  AllocationHeaderDto,
  AllocationListDto,
  AllocationFilterDto,
  CreateAllocationRequest,
  UpdateAllocationRequest,
} from '@/types/allocation.types';

export const allocationApi = {
  /** GET /api/v1/allocations — paged list */
  getList: (filter?: AllocationFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<AllocationListDto>>>('/allocations', { params: filter }),

  /** GET /api/v1/allocations/{id} — full header with details */
  getById: (id: string) =>
    apiClient.get<ApiResponse<AllocationHeaderDto>>(`/allocations/${id}`),

  /** POST /api/v1/allocations — create allocation (draft or confirmed) */
  create: (data: CreateAllocationRequest) =>
    apiClient.post<ApiResponse<string>>('/allocations', data),

  /** PUT /api/v1/allocations/{id} — update draft allocation header + lines */
  update: (id: string, data: UpdateAllocationRequest) =>
    apiClient.put<ApiResponse<object>>(`/allocations/${id}`, data),

  /** POST /api/v1/allocations/{id}/submit — submit draft for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/allocations/${id}/submit`),

  /** POST /api/v1/allocations/{id}/approve — approve a submitted allocation */
  approve: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/allocations/${id}/approve`),

  /** POST /api/v1/allocations/{id}/confirm — confirm allocation */
  confirm: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/allocations/${id}/confirm`),

  /** POST /api/v1/allocations/{id}/cancel — cancel allocation */
  cancel: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/allocations/${id}/cancel`),

  /** POST /api/v1/allocations/{id}/reverse — reverse with reason */
  reverse: (id: string, reason: string) =>
    apiClient.post<ApiResponse<string>>(`/allocations/${id}/reverse`, { reason }),
};
